module.exports = __webpack_public_path__ + "static/media/x.ce288b64.svg";